import { z } from 'zod';
import {
  parseOTPInputValue,
  OTP_INPUT_OBJECT_SCHEMA,
  OTP_INPUT_OBJECT_SCHEMA_OR_EMPTY,
} from '../../components/OTPInput';

/**
 * Normalise Australian mobile number to +614xxxxxxxx format.
 * Australian mobiles always start with 04 (local) or +614 (international).
 */
export const normaliseAusMobile = (phone) => {
  const stripped = phone.trim().replace(/[\s\-()]/g, '');

  if (/^04\d{8}$/.test(stripped)) {
    return `+61${stripped.slice(1)}`;
  }

  if (/^4\d{8}$/.test(stripped)) {
    return `+61${stripped}`;
  }

  if (/^614\d{8}$/.test(stripped)) {
    return `+${stripped}`;
  }

  if (/^\+614\d{8}$/.test(stripped)) {
    return stripped;
  }

  return stripped;
};

const isValidAusMobile = (phone) => /^\+614\d{8}$/.test(normaliseAusMobile(phone));

export const smsSchema = z
  .object({
    phoneNumber: z
      .string()
      .min(1, 'Phone number is required')
      .transform((val) => val.trim())
      .refine(isValidAusMobile, {
        message: 'Please enter a valid Australian mobile number (e.g. 0400 000 000)',
      }),
    verificationCode: OTP_INPUT_OBJECT_SCHEMA.or(OTP_INPUT_OBJECT_SCHEMA_OR_EMPTY),
  })
  .refine(
    (data) => {
      const verificationCode = parseOTPInputValue(data.verificationCode);

      // If the verification code is empty, we need to check if the user has entered the code
      if (verificationCode.length === 0) {
        return OTP_INPUT_OBJECT_SCHEMA_OR_EMPTY.safeParse(data.verificationCode).success;
      }

      return OTP_INPUT_OBJECT_SCHEMA.safeParse(data.verificationCode).success;
    },
    {
      message: 'Verification code is invalid',
      path: ['verificationCode'],
    },
  );
